import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tabs, Tab } from "react-bootstrap";
import SlotPicker from "./SlotPicker";
import { LUNCH, DINNER } from "../../../utilities/slots";

export default function DeliverySlots() {
  const [lunchSlots, setLunchSlots] = useState([]);
  const [dinnerSlots, setdinnerSlots] = useState([]);
  const [key, setKey] = useState("lunch");
  useEffect(() => {
    const fetchslots = async () => {
      const { data } = await axios.get("/api/slots");
      setLunchSlots(data[0].lunchSlots);
      setdinnerSlots(data[0].dinnerSlots);
    };
    fetchslots();
  }, []);
  const addSlots = async (v) => {
    const id = key === "lunch" ? lunchSlots.length + 1 : dinnerSlots.length + 1;
    const slot_name = `Slot ${id}`;
    const slot = { id, slot_name, slot_time: v };
    if (key === "lunch") {
      setLunchSlots([...lunchSlots, slot]);
      const { data } = await axios.put("/api/slots/61601a6cd0b32f4f0cdf35aa", { lunchSlots: [...lunchSlots, slot], dinnerSlots });
      alert(data.msg);
    } else {
      setdinnerSlots([...dinnerSlots, slot]);
      const { data } = await axios.put("/api/slots/61601a6cd0b32f4f0cdf35aa", { lunchSlots, dinnerSlots: [...dinnerSlots, slot] });
      alert(data.msg);
    }
  };
  const deleteSlots = async (id) => {
    const slots = key === "lunch" ? [...lunchSlots] : [...dinnerSlots];
    slots.splice(id, 1);
    if (key === "lunch") {
      setLunchSlots(slots);
      const { data } = await axios.put("/api/slots/61601a6cd0b32f4f0cdf35aa", { lunchSlots: slots, dinnerSlots });
      alert(data.msg);
    } else {
      setdinnerSlots(slots);
      const { data } = await axios.put("/api/slots/61601a6cd0b32f4f0cdf35aa", { lunchSlots, dinnerSlots: slots });
      alert(data.msg);
    }
  };

  return (
    <Tabs defaultActiveKey="lunch" onSelect={(key) => setKey(key)} className="mt-2">
      <Tab eventKey="lunch" title="Lunch">
        <SlotPicker
          slots={lunchSlots}
          timepicker={LUNCH}
          addSlots={addSlots}
          deleteSlots={deleteSlots}
        />
      </Tab>
      <Tab eventKey="dinner" title="Dinner">
        <SlotPicker
          slots={dinnerSlots}
          timepicker={DINNER}
          addSlots={addSlots}
          deleteSlots={deleteSlots}
        />
      </Tab>
    </Tabs>
  );
}
